import css from 'styled-jsx/css';

const styles = css.global`.proposal {
  overflow: hidden;
}

.proposal.hidden {
  display: none !important;
}

.proposal.exclusive-modal {
  display: none !important;
}

.proposal .info-title {
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-size: 32px;
  line-height: 42px;
  letter-spacing: 0%;
  color: #222;
  max-width: 288px;
  margin: 24px 0;
}

.proposal .info-boxes {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.proposal .box-project {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;

  border: 1px solid #cccccc;
  border-radius: 6px;
  background: #fff;

  box-sizing: border-box;
}

.proposal .box-project .box-title {
  font-family: 'SantanderText';
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  color: #222;
  margin: 0;
}

.proposal .box-project .box-text {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #222;
  margin: 0;
}

.proposal .box-project .box-icon {
  width: 100%;
  height: auto;
  max-width: 32px;
  display: block;
  margin: 0;
  padding: 0;
}

.proposal .box-project .mt {
  margin-top: 8px;
}

.proposal .offer-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
}

.proposal .offer-list .offer-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}

.proposal .offer-list .offer-icon {
  width: 100%;
  height: auto;
  max-width: 24px;
  display: block;
  margin: 0;
  padding: 0;
}

.proposal .text-disclaimer {
  color: #444;
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  margin: 8px 0 24px;
}

.proposal .button-row-form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  padding-top: 24px;
  margin: 66px 0 0;
  border-top: 1px solid #cccccc;
}

.proposal .hide-mobile {
  display: none;
}

.proposal .inputs-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  margin-bottom: 24px;
}

.proposal .text-subtitle {
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  margin: 0;
  color: #222;
}

.proposal .custom-clear-button {
  position: relative;
  width: fit-content;
  max-width: 288px;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
  color: #cc0000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 48px;
  margin: 24px 0;
  cursor: pointer;
}

.proposal .btn-insert-voucher img {
  pointer-events: none;
  max-width: 24px;
  height: auto;
}

.proposal .first-due-date {
  margin-top: 30px;
}

.proposal .divider {
  color: #cccccc;
  background: #cccccc;
  display: block;
  height: 1px;
  width: 100%;
  border: none;
  margin: 24px 0;
}

.proposal .text-subtitle-2 {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #222;
}

.proposal .tips {
  overflow: visible;
  position: relative;
  background: #deedf2;
  padding: 16px;
  border-radius: 6px;
  margin-top: 20px;
}

.proposal .tips b {
  font-family: 'SantanderText';
  font-weight: 800;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #444;
  margin: 0 0 8px;
  display: block;
}

.proposal .tips p {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -2%;
  color: #444;
  margin: 0;
  max-width: 208px;
}

.proposal .ctn-home-24 {
  overflow: visible;
}
.proposal .tips .img-tip {
  display: flex;
  padding: 0;
  margin: 0;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  object-fit: contain;
  max-width: 54px;
  height: auto;
  position: absolute;
  right: 0;
  top: -12px;
  pointer-events: none;
  z-index: 1;
}

.proposal .title-installment {
  margin-top: 24px;
}

.proposal .radio-group {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
}

.proposal .text-subtitle-3 {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  color: #444;
  margin-top: 24px;
}

.proposal .form-render {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  max-width: 420px;
}

.proposal .protection {
  margin-top: 40px;
}

.proposal .protection .text-title-insurance {
  font-family: SantanderText;
  font-weight: bold;
  font-size: 32px;
  line-height: 48px;
  letter-spacing: 0%;
  color: #222;
  margin: 0;
  padding: 0;
}

.proposal .protection .text-subtitle {
  margin: 24px 0 16px;
}

.proposal .protection .seguro-info {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;

  border: 1px solid #cccccc;
  border-radius: 4px;

  padding: 16px;
  box-sizing: border-box;

  margin: 16px 0 32px;
}

.proposal .protection .seguro-info p {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  vertical-align: middle;

  color: #444;
}

.proposal .insurance {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
}

.proposal .insurance-card {
  box-sizing: border-box;
  position: relative;

  flex: 1;
  max-width: 100%;
}

.proposal .insurance-card .card-title {
  font-family: SantanderText;
  font-weight: bold;
  font-size: 32px;
  line-height: 48px;
  letter-spacing: 0%;
  color: #222;
  margin: 0;
}

.proposal .insurance-card .card-status {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-top: 8px;
}

.proposal .insurance-card .status-flag {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 8px;
  font-family: SantanderMicroText;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  text-align: center;
  border-radius: 4px;
  max-width: 130px;
  background: #c00;
}

.proposal .insurance-card .status-flag.included {
  color: #fff;
  background: #739e41;
  max-width: 70px;
}

.proposal .insurance-card .card-header {
  margin-bottom: 24px;
}

.proposal .insurance-card .card-text {
  font-family: SantanderMicroText;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  color: #444;
  margin: 0;
}

.proposal .insurance-card .card-value {
  color: #222;
  display: block;
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-style: Regular;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
}

.proposal .insurance-card .card-value b {
  font-weight: 800;
}

.proposal .insurance-card .card-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 16px;
}
.proposal .insurance-card .card-item:last-of-type {
  margin-bottom: 24px;
}

.proposal .insurance-card .card-item .card-text {
  margin: 0;
}

.proposal .insurance-card .btn-show-more {
  height: auto;
  text-align: center;
  color: #cc0000;
  font-family: SantanderText;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  width: 132px;
  text-decoration: underline;
}

.proposal .insurance-card .chk-insurance {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
}

.proposal .btn-remove-insurance {
  min-height: 28px;
  text-align: center;
  color: #cc0000;
  font-family: SantanderText;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: center;
  padding: 0;
  margin: 16px 0 0;
  width: 100%;
  text-decoration: underline;
  text-align: left;
  margin-top: 34px;
}

.proposal .voucher-arrow {
  display: none;
}

.proposal.hide-resume .info-boxes,
.proposal.hide-resume .text-disclaimer {
  display: none;
}

.proposal .first-due-date .sn-datepicker-inline {
  margin-top: 8px;
}

.proposal .sn-datepicker-inline .react-datepicker .custom-date-header .date-select {
  background: transparent;
}

.proposal .protection.not-available {
  display: none !important;
}

@media (min-width: 992px) {
  .proposal .info-title {
    font-size: 40px;
    line-height: 60px;
    max-width: unset;
    margin: 40px 0;
  }

  .proposal .info-boxes {
    flex-direction: row;
    gap: 16px;
  }

  .proposal .box-project {
    flex: 1;
  }

  .proposal .box-project .box-icon {
    max-width: 48px;
  }

  .proposal .text-disclaimer {
    margin-bottom: 40px;
  }

  .proposal .button-row-form {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  .proposal .voucher-arrow {
    display: block;
    margin-left: 34px;
  }

  .proposal .button-row-form button:nth-child(1) {
    max-width: 120px;
  }
  .proposal .button-row-form button:nth-child(2) {
    max-width: 228px;
  }

  .proposal .hide-mobile {
    display: block;
  }

  .proposal .inputs-wrapper {
    flex-direction: row;
    gap: 24px;
    margin-top: 24px;
    margin-bottom: 40px;
  }

  .proposal .inputs-wrapper .field-wrapper {
    flex: 1;
    max-width: 240px;
  }

  .proposal .select-installment {
    display: none;
  }

  .proposal .installment-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24px;
  }

  .proposal .installment-radio {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    height: 90px;
    width: 250px;

    box-shadow: 0px 2px 8px -2px #22222266;
    border: 1px solid #cccccc;
    border-radius: 4px;

    padding: 16px;
    margin: 0;

    cursor: pointer;
  }

  .proposal .installment-radio.disabled {
    opacity: 0.4 !important;
  }

  .proposal .installment-radio.selected {
    border: 1px solid #cc0000;
    transition: border-color 0.15s ease;
  }

  .proposal .installment-radio .text-1,
  .proposal .installment-radio .text-2 {
    font-family: 'SantanderMicroText';
    font-style: Bold;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0%;
    color: #222;
    margin: 0;
  }

  .proposal .installment-radio .text-2 {
    font-size: 24px;
    line-height: 36px;
    font-weight: bold;
  }

  .proposal .title-installment {
    margin-top: 40px;
  }

  .proposal .first-due-date {
    max-width: 270px;
  }

  .proposal .divider {
    margin: 40px 0;
  }

  .proposal .text-subtitle-2 {
    font-family: 'SantanderHeadline';
    font-weight: 800;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0%;
    color: #222;
  }

  .proposal .tips {
    margin-top: 52px;
    max-width: 410px;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  .proposal .tips p {
    font-size: 16px;
    line-height: 150%;
    max-width: 345px;
  }

  .proposal .radio-group {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 56px;
  }

  .proposal .insurance-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24px;
    margin-top: 32px;
  }

  .proposal .protection .text-subtitle {
    margin-top: 0;
  }

  .proposal .protection .text-title-insurance {
    color: #222;
    font-family: SantanderText;
    font-weight: 600;
    font-size: 32px;
    line-height: 48px;
    letter-spacing: 0%;
    margin-bottom: 16px;
  }

  .proposal .protection .text-subtitle-2 {
    font-family: SantanderText;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0%;
    margin: 16px 0;
  }

  .proposal .protection .insurance-wrapper > div {
    flex: 1;
  }

  .proposal .protection .seguro-info {
    align-items: center;
    justify-content: flex-start;
    margin-top: 32px;
  }

  .proposal .btn-remove-insurance {
    width: auto;
    margin-right: auto;
  }

  .proposal .insurance-card .card-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
  }

  .proposal .insurance-card .card-status {
    margin: 0;
    flex: 1;
  }
}
`;

export default styles;